import React from 'react';
import { useNavigate } from 'react-router-dom';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type Props = {
  seriesName: string;
  message?: string;
  nextSeries?: {
    label: string;
    path: string;
  };
};

/**
 * 編の完了バナー + 次の編へのリンク
 */
const WorkflowSeriesComplete: React.FC<Props> = ({ seriesName, message, nextSeries }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        borderRadius: 3,
        p: 3,
        textAlign: 'center',
        bgcolor: '#1b5e20',
      }}
    >
      <CheckCircleOutlineIcon sx={{ fontSize: 36, color: '#fff', mb: 1 }} />
      <Typography variant="subtitle1" fontWeight={700} sx={{ color: '#fff' }}>
        {seriesName} 完了
      </Typography>
      {message && (
        <Typography variant="body2" sx={{ mt: 0.5, color: 'rgba(255,255,255,0.85)' }}>
          {message}
        </Typography>
      )}
      {nextSeries && (
        <Stack alignItems="center" sx={{ mt: 2 }}>
          <Button
            variant="outlined"
            endIcon={<ArrowForwardIcon />}
            onClick={() => navigate(nextSeries.path)}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 2,
              color: '#fff',
              borderColor: 'rgba(255,255,255,0.6)',
              '&:hover': { borderColor: '#fff', bgcolor: 'rgba(255,255,255,0.1)' },
            }}
          >
            {nextSeries.label}に進む
          </Button>
        </Stack>
      )}
    </Box>
  );
};

export default WorkflowSeriesComplete;
